const advanceInvoiceInstallment = {
  'advanceInvoiceInstallment.title': 'Adiantar Parcelamento de Fatura',
  'advanceInvoiceInstallment.emptyState':
    'Não há parcelamento de fatura para adiantar.',
  'advanceInvoiceInstallment.errorState':
    'Não foi possível obter os dados de parcelamento de fatura.',
  'advanceInvoiceInstallment.confirm': 'Confirmar',
  'advanceInvoiceInstallment.outcomeSuccess':
    'Parcelamento de Fatura adiantado',
  'advanceInvoiceInstallment.close': 'Fechar',

  'advanceInvoiceInstallment.firstPaymentDate': 'Data de pagamento da entrada',
  'advanceInvoiceInstallment.firstPaymentAmount': 'Valor da entrada',
  'advanceInvoiceInstallment.numberInstallments':
    'Número de parcelas contratadas',
  'advanceInvoiceInstallment.contractAmount': 'Valor total do contrato',
  'advanceInvoiceInstallment.principalAmount': 'Valor financiado',
  'advanceInvoiceInstallment.installmentAmount': 'Valor da parcela',
  'advanceInvoiceInstallment.interestRate': 'Taxa de juros do parcelamento',

  'advanceInvoiceInstallment.noAdvanceInvoiceInstallmentOptions':
    'Não há opções de adiantamento de parcelas de fatura parcelada',
  'advanceInvoiceInstallment.installmentsToAdvance': 'Parcelas a adiantar',
  'advanceInvoiceInstallment.totalAmount': 'Valor Total',
  'advanceInvoiceInstallment.inAdvance': 'Adiantado',
};

export default advanceInvoiceInstallment;
